<template>
  <div class="bg-gray-50 dark:bg-gray-800">
    <main class="bg-gray-50 dark:bg-gray-900">
      <slot role="main" />
    </main>
  </div>
</template>

<script setup>
</script>